import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '@/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export default function CustomerVerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('Wir bestätigen deine E-Mail-Adresse...');

  useEffect(() => {
    const token = (searchParams.get('token') || '').trim();
    if (!token) {
      setStatus('error');
      setMessage('Ungültiger Link (Token fehlt).');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        await api.customerVerifyEmail(token);
        if (cancelled) return;
        setStatus('ok');
        setMessage('E-Mail-Adresse bestätigt. Du kannst dich jetzt anmelden.');
      } catch (e) {
        if (cancelled) return;
        setStatus('error');
        setMessage(e?.message || 'Bestätigung fehlgeschlagen.');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader>
            <CardTitle>E-Mail bestätigen</CardTitle>
            <CardDescription>Damit dein Account aktiv wird</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {status === 'error' ? (
              <Alert variant="destructive">
                <AlertDescription>{message}</AlertDescription>
              </Alert>
            ) : (
              <Alert>
                <AlertDescription>{message}</AlertDescription>
              </Alert>
            )}

            <Button asChild className="w-full">
              <Link to="/customer/login">Zur Anmeldung</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
